import { render, staticRenderFns } from "./VariationTextSelector.vue?vue&type=template&id=172abad2&scoped=true&"
import script from "./VariationTextSelector.vue?vue&type=script&lang=js&"
export * from "./VariationTextSelector.vue?vue&type=script&lang=js&"
import style0 from "./VariationTextSelector.vue?vue&type=style&index=0&id=172abad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172abad2",
  null
  
)

export default component.exports